import Suspense from "components/shared/Suspense";
import Button from "hardcover-ui/components/Button";
import { lazy, useState } from "react";
import { BookSerializersBookByline, EditionSerializersEdition } from "types/serializers";

const EditEditionModal = lazy(() =>
  import("features/librarians").then((module) => ({
    default: module.EditEditionModal,
  }))
);

export default function EditEditionButton({
  book,
  edition,
}: {
  book: BookSerializersBookByline;
  edition: EditionSerializersEdition;
}) {
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(!open);
  };

  return (
    <>
      <Button variant="tertiary" size="sm" onClick={() => setOpen(!open)}>
        <span className="lg:hidden">Set length</span>
        <span className="hidden lg:inline">
          Set edition length to track progress
        </span>
      </Button>

      {open ? (
        <Suspense fallback={null}>
          <EditEditionModal book={book} edition={edition} onClose={onClose} />
        </Suspense>
      ) : (
        false
      )}
    </>
  );
}
